import React, {Component, useRef} from "react"
import deleteIcon from '../images/delete.png'
import searchIcon from '../images/search.png'

class InputSearchWidget extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			placeholder: props.placeholder,
			value: props.value,
			cStyle: props.cStyle,
			onEnterPress: props.onEnterPress,
			onSearchClick: props.onSearchClick,
			onValueChanged: props.onChange,
			isNumeric: (props.isNumeric != null)? props.isNumeric: false,
			disabled: props.disabled
		}
		this.onEnterPress = this.onEnterPress.bind(this)
		this.onSearchClick = this.onSearchClick.bind(this)
		this.onValueChanged = this.onValueChanged.bind(this)
		this.input = React.createRef()
	}

	onEnterPress(v) {
		if(this.state.onEnterPress != null) {
			this.state.onEnterPress(v)
		}
	}

	onSearchClick(v) {
		if(this.state.onSearchClick != null) {
			this.state.onSearchClick(v)
		}
		// this.input.current.style.backgroundImage = "url('../images/trash_green.png')"
	}

	onValueChanged (v) {
		if(this.state.onValueChanged != null) {
			this.state.onValueChanged(v)
		}
	}

	componentDidUpdate(prevProps) {
		if(this.props.placeholder != prevProps.placeholder) {
			this.setState({
				// value: this.props.placeholder,
				placeholder: this.props.placeholder
			})
		}
		if(this.props.value != prevProps.value) {
			this.setState({
				value: this.props.value
			})
		}
	}

	render() {
		return(<div className="input-search-widget" style={this.state.cStyle}>
			<input type="text" class="isw-input" value={this.state.value} placeholder={this.state.placeholder}
				onClick={(e) => {
					e.target.select()
				}}
				onChange={e => {
					if(this.state.isNumeric) {
						if(isNaN(parseInt(e.target.value))) {
							e.target.value = "";
						}
					}
					this.onValueChanged(e.target.value)
					this.setState({value: e.target.value, placeholder: e.target.value})
				}}
				onKeyPress={e => {
					if(e.charCode === 13) {
						this.onEnterPress(this.state.value)
					}
				}} disabled={this.state.disabled} ref={this.input} />
			<div onClick={() => {
				if(!this.state.disabled) {
					this.onSearchClick(this.state.value)
				}
			}}></div>
		</div>)
	}
}

export default InputSearchWidget
